import { useOneTimeFlag } from '@/hooks/use-one-time-flag';

const NFT_ATTENTION_FLAG_ID = 'sidebar.nft.attention';

export function useNftAttention() {
	const nftFlag = useOneTimeFlag(NFT_ATTENTION_FLAG_ID);

	return {
		shouldShowNftBadge: !nftFlag.hasSeen,
		dismissNftBadge: nftFlag.markSeen,
	};
}
